import axios from 'axios'
import store from '@/store'

export default {
  fetchNotBudgetTasks (formData) {
    return new Promise((resolve, reject) => {
      axios.post('/api/issues/not_budgeted', formData, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        store.dispatch('setNotBudgetIssues', data)
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  }
}
